<main class="main">
  <div class="main-content">
    <!-- Header della pagina -->
    <div class="manifest-header">
      <div class="header-info">
        <div class="title-section">
          <h1 class="main-title">{{ 'MANIFEST.TITLE' | translate }}</h1>
          <p class="main-subtitle">{{ 'MANIFEST.SUBTITLE' | translate }}</p>
        </div>
      </div>
      
      <!-- Azioni dell'header -->      <div class="header-actions">
        <div class="quick-add">
          <input type="text" class="form-control" placeholder="Aggiungi Bolla automaticamente al Borderò" />
          <button class="btn btn-primary">Aggiungi</button>
        </div>
      </div>
    </div>

    <!-- Barra delle azioni -->
    <div class="action-bar">
      <div class="left-actions">
        <div class="dropdown filter-dropdown">
          <button class="action-btn secondary dropdown-toggle" type="button" id="warehouseDropdown" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="fas fa-warehouse"></i>
            <span class="action-text">{{ selectedWarehouse ? (selectedWarehouse | translate) : ("MANIFEST.STATUS.WAREHOUSE" | translate) }}</span>
          </button>
          <ul class="dropdown-menu" aria-labelledby="warehouseDropdown">
            <li>
              <a class="dropdown-item" (click)="selectedWarehouse=''; applyFilters()">
                {{ 'MANIFEST.STATUS.ALL' | translate }}
              </a>
            </li>
            <li *ngFor="let warehouse of warehouses">
              <a class="dropdown-item" (click)="selectedWarehouse=warehouse.name; applyFilters()">
                {{ warehouse.name | translate }}
              </a>
            </li>
          </ul>
        </div>
        
        <button class="action-btn primary">
          <i class="fa fa-plus-circle"></i>
          <span class="action-text">{{ 'MANIFEST.INSERT.TITLE' | translate }}</span>
        </button>
        
        <button class="action-btn secondary" (click)="refreshManifests()" [disabled]="isLoading">
          <i class="fa fa-refresh" [class.fa-spin]="isLoading"></i>
          <span class="action-text">{{ 'MANIFEST.REFRESH' | translate }}</span>
        </button>
        
        <div class="date-filter">
          <button class="action-btn date-nav" (click)="decrementDate()">
            <i class="fa fa-chevron-left"></i>
          </button>          <button #datePickerButton class="action-btn secondary date-display" (click)="openDatePicker()">
            <i class="fa fa-calendar-day"></i>
            <span class="action-text">{{ selectedDate | date:'dd/MM/yyyy' }}</span>
          </button>
          <button class="action-btn date-nav" (click)="incrementDate()">
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>
      
      <div class="right-actions">
        <div class="search-bar">
          <i class="fa fa-search search-icon"></i>
          <input
            type="text"
            class="form-control"
            placeholder="{{ 'SEARCH.PAGE' | translate }}"
            [(ngModel)]="searchQuery"
            (input)="applyFilters()"
          />
        </div>
        
        <div class="dropdown filter-dropdown">
          <button class="action-btn secondary dropdown-toggle" type="button" id="statusDropdown" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="fas fa-filter"></i>
            <span class="action-text">{{ selectedStatus ? ('MANIFEST.STATUS.' + selectedStatus | translate) : ('MANIFEST.STATUS.FILTER' | translate) }}</span>
          </button>
          <ul class="dropdown-menu" aria-labelledby="statusDropdown">
            <li>
              <a class="dropdown-item" (click)="selectedStatus=''; applyFilters()">
                {{ 'MANIFEST.STATUS.ALL' | translate }}
              </a>
            </li>
            <li *ngFor="let status of manifestStatuses">
              <a class="dropdown-item" (click)="selectedStatus=status; applyFilters()">
                {{ 'MANIFEST.STATUS.' + status | translate }}
              </a>
            </li>
          </ul>
        </div>
        
        <button class="action-btn icon-only" (click)="toggleView()">
          <i class="fa" [ngClass]="isCardView ? 'fa-list' : 'fa-th-large'"></i>
        </button>
      </div>
    </div>    <div class="manifest-content">      <!-- Loader -->
      <ng-container *ngIf="isLoading; else content">
        <!-- Skeleton loader per Cards -->
        <div class="skeleton-container" *ngIf="isCardView">
          <div class="card-skeleton" *ngFor="let i of [].constructor(8)">
            <div class="skeleton-header">
              <div class="skeleton-title"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="skeleton-body">
              <div class="skeleton-text"></div>
              <div class="skeleton-text"></div>
              <div class="skeleton-grid">
                <div class="skeleton-cell" *ngFor="let j of [].constructor(6)"></div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Skeleton loader per Tabella -->
        <div class="table-responsive" *ngIf="!isCardView">
          <table class="modern-table">
            <thead>
              <tr>
                <th *ngFor="let i of [].constructor(11)">
                  <div class="skeleton-title"></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let i of [].constructor(8)">
                <td *ngFor="let j of [].constructor(11)">
                  <div class="skeleton-row"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      
      <app-popup *ngIf="isPopupOpen" [visible]="isPopupOpen" [title]="'MANIFEST.POPUP.TITLE' | translate"
        [message]="'MANIFEST.POPUP.SUBTITLE' | translate" (closed)="closePopup()">
      </app-popup>      <ng-template #content>
        <!-- Messaggio quando non ci sono manifesti -->
        <div *ngIf="manifests.length === 0" class="no-results-message">
          <div class="alert alert-warning">
            <i class="fas fa-exclamation-triangle"></i>
            <span>{{ 'MANIFEST.NO_MANIFESTS' | translate }}</span>
            <button class="action-btn primary" (click)="refreshManifests()">
              <i class="fa fa-refresh"></i>
              <span class="action-text">{{ 'MANIFEST.REFRESH' | translate }}</span>
            </button>
          </div>
        </div>        <!-- Messaggio quando ci sono manifesti ma nessun risultato con i filtri applicati -->
        <div *ngIf="manifests.length > 0 && filteredManifests.length === 0" class="no-results-message">
          <div class="alert alert-info">
            <i class="fas fa-info-circle"></i>
            <span>{{ 'MANIFEST.NO_RESULTS' | translate }}</span>
            <div class="filter-summary" *ngIf="selectedStatus || selectedWarehouse || searchQuery">
              <span class="filter-summary-title">{{ 'MANIFEST.FILTER_DESCRIPTION' | translate }}</span>
              <span *ngIf="selectedStatus">
                <strong>{{ 'MANIFEST.APPLIED_FILTERS.STATUS' | translate }}:</strong> {{ 'MANIFEST.STATUS.' + selectedStatus | translate }}
              </span>
              <span *ngIf="selectedWarehouse">
                <strong>{{ 'MANIFEST.APPLIED_FILTERS.WAREHOUSE' | translate }}:</strong> {{ selectedWarehouse }}
              </span>
              <span *ngIf="searchQuery">
                <strong>{{ 'MANIFEST.APPLIED_FILTERS.SEARCH' | translate }}:</strong> "{{ searchQuery }}"
              </span>
              <span>
                <strong>{{ 'MANIFEST.APPLIED_FILTERS.DATE' | translate }}:</strong> {{ selectedDate | date:'dd/MM/yyyy' }}
              </span>
            </div>
            <button class="btn btn-sm btn-outline-primary ml-2" (click)="resetFilters()">
              {{ 'MANIFEST.RESET_FILTERS' | translate }}
            </button>
          </div>
        </div>
          <!-- Contenuto reale - mostra solo quando ci sono manifesti filtrati -->
        <ng-container *ngIf="manifests.length > 0 && filteredManifests.length > 0">
          <ng-container *ngIf="isCardView; else tableView">
            <div class="card-grid">
              <div *ngFor="let manifest of filteredManifests" class="manifest-card" (click)="navigateToDetails(manifest.code)">
                <div class="card-header">
                  <div class="card-title">
                    <h3>{{ manifest.title }}</h3>
                    <span class="card-code">{{ manifest.code }}</span>
                  </div>
                </div>
                
                <div class="card-body">
                  <p class="card-description">{{ manifest.description }}</p>
                  
                  <div class="info-grid">
                    <div class="info-group">
                      <div class="info-icon">
                        <i class="fas fa-calendar-alt"></i>
                      </div>
                      <div class="info-content">
                        <span class="info-label">{{ 'MANIFEST.PARAMS.DATE' | translate }}</span>
                        <span class="info-value">{{ manifest.date }}</span>
                      </div>
                    </div>
                    
                    <div class="info-group">
                      <div class="info-icon">
                        <i class="fas fa-map-marker-alt"></i>
                      </div>
                      <div class="info-content">
                        <span class="info-label">{{ 'MANIFEST.PARAMS.LOCATION' | translate }}</span>
                        <span class="info-value">{{ manifest.location }}</span>
                      </div>
                    </div>
                    
                    <div class="info-group">
                      <div class="info-icon">
                        <i class="fas fa-clock"></i>
                      </div>
                      <div class="info-content">
                        <span class="info-label">{{ 'MANIFEST.PARAMS.TIMESTART' | translate }}</span>
                        <span class="info-value">{{ manifest.timeStart }}</span>
                      </div>
                    </div>
                    
                    <div class="info-group">
                      <div class="info-icon">
                        <i class="fas fa-file-alt"></i>
                      </div>
                      <div class="info-content">
                        <span class="info-label">{{ 'MANIFEST.PARAMS.WAYBILLS' | translate }}</span>
                        <span class="info-value">{{ manifest.waybills }}</span>
                      </div>
                    </div>
                    
                    <div class="info-group">
                      <div class="info-icon">
                        <i class="fas fa-box"></i>
                      </div>
                      <div class="info-content">
                        <span class="info-label">{{ 'MANIFEST.PARAMS.PARCELS' | translate }}</span>
                        <span class="info-value">{{ manifest.parcels }}</span>
                      </div>
                    </div>
                    
                    <div class="info-group" *ngIf="manifest.note">
                      <div class="info-icon">
                        <i class="fas fa-sticky-note"></i>
                      </div>
                      <div class="info-content">
                        <span class="info-label">{{ 'MANIFEST.PARAMS.NOTE' | translate }}</span>
                        <span class="info-value note-text">{{ manifest.note }}</span>
                      </div>
                    </div>
                  </div>
                </div>                <div class="card-footer">
                  <div class="card-actions">
                    <button class="action-btn icon-only small" (click)="openPopup(); $event.stopPropagation()" title="{{ 'DETAILS.ACTIONS.PRINT' | translate }}">
                      <i class="fa fa-print"></i>
                    </button>
                    <button class="action-btn icon-only small" (click)="openPopup(); $event.stopPropagation()" title="{{ 'DETAILS.ACTIONS.EMAIL' | translate }}">
                      <i class="fa fa-envelope"></i>
                    </button>
                    <button class="action-btn icon-only small" (click)="openPopup(); $event.stopPropagation()" title="{{ 'DETAILS.ACTIONS.SETTINGS' | translate }}">
                      <i class="fa fa-cog"></i>
                    </button>
                    <button class="action-btn icon-only small" (click)="openPopup(); $event.stopPropagation()">
                      <i class="fa fa-code-branch"></i>
                    </button>
                    <div class="status-badge inline-badge" [ngClass]="manifest.status.toLowerCase()">
                      {{ 'MANIFEST.STATUS.' + manifest.status | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>        <!-- Vista TABELLA -->
          <ng-template #tableView>
            <div class="table-responsive">
              <table class="modern-table">
                <thead>
                  <tr>
                    <th>{{ 'MANIFEST.TABLE.HEADERS.TITLE' | translate }}</th>
                    <th>{{ 'MANIFEST.TABLE.HEADERS.CODE' | translate }}</th>
                    <th>{{ 'MANIFEST.TABLE.HEADERS.DESCRIPTION' | translate }}</th>
                    <th>{{ 'MANIFEST.TABLE.HEADERS.DATE' | translate }}</th>
                    <th>{{ 'MANIFEST.TABLE.HEADERS.LOCATION' | translate }}</th>
                    <th>{{ 'MANIFEST.TABLE.HEADERS.TIMESTART' | translate }}</th>
                    <th>{{ 'MANIFEST.TABLE.HEADERS.WAYBILLS' | translate }}</th>
                    <th>{{ 'MANIFEST.TABLE.HEADERS.PARCELS' | translate }}</th>
                    <th>{{ 'MANIFEST.TABLE.HEADERS.NOTE' | translate }}</th>
                    <th>{{ 'MANIFEST.TABLE.HEADERS.STATUS' | translate }}</th>
                    <th>{{ 'MANIFEST.TABLE.HEADERS.ACTIONS' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let manifest of filteredManifests" (click)="navigateToDetails(manifest.code)" class="table-row-hover">
                    <td class="title-cell">{{ manifest.title }}</td>
                    <td class="code-cell">{{ manifest.code }}</td>
                    <td class="description-cell">{{ manifest.description }}</td>
                    <td>{{ manifest.date }}</td>
                    <td>{{ manifest.location }}</td>
                    <td>{{ manifest.timeStart }}</td>
                    <td class="numeric-cell">{{ manifest.waybills }}</td>
                    <td class="numeric-cell">{{ manifest.parcels }}</td>
                    <td>
                      <button class="action-btn icon-only tiny" (click)="openPopup(); $event.stopPropagation()" *ngIf="manifest.note && manifest.note.length > 0" title="{{ manifest.note }}">
                        <i class="fa fa-sticky-note"></i>
                      </button>
                    </td>
                    <td>
                      <span class="status-badge table-badge" [ngClass]="manifest.status.toLowerCase()">
                        {{ 'MANIFEST.STATUS.' + manifest.status | translate }}
                      </span>
                    </td>
                    <td>
                      <div class="table-actions">
                        <button class="action-btn icon-only tiny" (click)="openPopup(); $event.stopPropagation()" title="{{ 'DETAILS.ACTIONS.PRINT' | translate }}">
                          <i class="fa fa-print"></i>
                        </button>
                        <button class="action-btn icon-only tiny" (click)="openPopup(); $event.stopPropagation()" title="{{ 'DETAILS.ACTIONS.EMAIL' | translate }}">
                          <i class="fa fa-envelope"></i>
                        </button>
                        <button class="action-btn icon-only tiny" (click)="openPopup(); $event.stopPropagation()" title="{{ 'DETAILS.ACTIONS.SETTINGS' | translate }}">
                          <i class="fa fa-cog"></i>
                        </button>
                        <button class="action-btn icon-only tiny" (click)="openPopup(); $event.stopPropagation()">
                          <i class="fa fa-code-branch"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>
        </ng-container>
      </ng-template>
    </div>
  </div>
</main>